"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.moduleLibraryTabs = void 0;
exports.moduleLibraryTabs = {
    my: {
        text: "My",
        value: "my",
    },
    templates: {
        text: "Templates",
        value: "templates",
    },
    stepTemplates: {
        text: "Step templates",
        value: "step templates",
    },
    createdByOthers: {
        text: "Created by others",
        value: "created by others",
    },
    createdByMe: {
        text: "Created by me",
        value: "created by me",
    },
    archive: {
        text: "Archive",
        value: "archive",
    },
};
